import type { SavedFilter, ViewConfiguration } from '@/frontend/features/DashboardRuntime/types'

export default function ViewFilterEditor({ specs, values, onChange }: {
  specs: SavedFilter[]; values: ViewConfiguration['filters']; onChange: (value: ViewConfiguration['filters']) => void
}) {
  const change = (spec: SavedFilter, value: string) => {
    const next = { ...values }
    if (!value) delete next[spec.name]
    else next[spec.name] = spec.type === 'number' ? Number(value) : value
    onChange(next)
  }
  const fieldClass = 'w-full rounded-md border bg-background p-2'
  return <>{specs.map(spec => <label key={spec.name} className="mb-2 block space-y-1 text-xs">{spec.label ?? spec.name}
    {spec.options?.length ? <select className={fieldClass} value={values[spec.name] ?? spec.default ?? ''} onChange={event => change(spec, event.target.value)}>
      {!spec.options.includes(String(spec.default ?? '')) && <option value="">—</option>}
      {spec.options.map(option => <option key={option} value={option}>{spec.option_labels?.[option] ?? option}</option>)}
    </select> : <input type={spec.type === 'date' ? 'date' : spec.type === 'number' ? 'number' : 'text'} step={spec.type === 'number' ? 'any' : undefined}
      className={fieldClass} maxLength={500} value={values[spec.name] ?? spec.default ?? ''} onChange={event => change(spec, event.target.value)} />}
  </label>)}</>
}
